import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const PerguntasController = {
    async ListPerguntas(Id) {
        try {
            const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}dashboard_page/perguntas/${Id}`, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.result;
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    },
    async ListPerguntasPattern() {
        try {
            const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/regex_ddl`, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.result;
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    },
    async ReProc(questionId, procType, newQuestion, regexOption) {
        try {
            const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `perguntas_page/reproc`, {
                question_id: questionId, 
                proc_type: procType, 
                new_question: newQuestion, 
                regex_option: regexOption,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });

            return response.data
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    },
    async ListPerguntaswithprompt(Id) {
        try {
            const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/get_questions_by_audit/${Id}`, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.result;
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    },
    async AddPerguntas(newNome, newModel, newSystem, newUser, Audit_id, notaValue, Context, words, qualifier) {
        try {
            const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `perguntas_page/add_perguntas`, {
                Nome: newNome,
                model: newModel,
                system: newSystem,
                user: newUser,
                audit_id: Audit_id,
                nota: notaValue,
                context: Context,
                words: words, 
                qualifier: qualifier
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error creating user:", error);
            throw error;
        }
    },
    async DeletePerguntas(Id) {
        try {
            const response = await axios.delete(
                `${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/${Id}`,
                {
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error deleting user:", error);
            throw error;
        }
    },
    async PutPerguntas(Id, Nome, context, nota, user, words, qualifier, question_seq) {
        try {
            const response = await axios.put(
                `${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/${Id}`,
                { Nome, context, nota, user, words, qualifier, question_seq },
                {
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating user:", error);
            throw error;
        }
    },
    async PutContext(Id, nome, context) {
        try {
            const response = await axios.put(
                `${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/edit_name_or_context/${Id}`,
                { nome, context },
                {
                    headers: {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating user:", error);
            throw error;
        }
    },
    async SearchedNome() {
        try {
            const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/show_questions_name`, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.result;
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    },
    async SearchedUser() {
        try {
            const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/show_questions_user`, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.result;
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    },
    async SearchedContext() {
        try {
            const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/get_contexts`, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.result;
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    },
    async AddMeta(questionId, metadadosDe, metadadosAte, WithDePara) {
        try {
            const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `perguntas_page/reproc_metadados`, {
                question_id: questionId,
                metadados_de: metadadosDe,
                metadados_ate: metadadosAte,
                with_de_para: WithDePara
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error creating user:", error);
            throw error;
        }
    },
    async UploadBase(file) {
        try {
            const formData = new FormData();
            formData.append('file', file);
    
            const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `perguntas_page/upload_metadados`, formData, {
                headers: {
                    'Authorization': `Bearer ${jwtToken}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            return response.data;
        } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        }
    },
    async AddContext(context) {
        try {
            const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `perguntas_page/add_context`, {
                context: context
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data
        } catch (error) {
            console.error("Error fetching transcripts:", error);
            throw error;
        }
    }
};

export default PerguntasController;